export enum AUTOMATIC_REPORT_PERIOD_TYPE_ENUM {
  Monthly = 1,
  Custom = 2,
  CustomIncludingThatDay = 3,
  Last24Hours = 4,
}
